import LiteTradeSearch from '../../../modules/LiteTrade/components/LiteTradeSearch/LiteTradeSearch';
import { MobileMarketMenuStyled } from './MobileMarketMenu/styled/MobileMarketMenuStyled';
import { MENU_COLLECTIONS_KEYS } from './MobileMarketMenu/MobileMarketMenuConstants';

const MobileMarketSkeleton = () => {

    return <LiteTradeSearch>
        <MobileMarketMenuStyled className='mt-1 mb-4 hidden-scrollbar'>
            {
                MENU_COLLECTIONS_KEYS.map((name) => <button
                        type="button"
                        className="btn btn-secondary btn-sm wave-background"
                        style={{ color: 'transparent' }}
                        key={name}
                    >
                        {name}
                    </button>,
                )
            }
        </MobileMarketMenuStyled>
        <div className='wave-background' style={{
            borderRadius: 12,
            padding: 16,
            boxShadow: '0 8px 16px rgba(9,10,16,0.3), 0 12px 32px rgba(9,10,16,0.4)',
            height: 214,
        }}></div>
        <div className='wave-background' style={{
            marginTop: 12,
            paddingTop: 12,
            borderRadius: 14,
            padding: 16,
            height: 28,
            width: 78,
        }}></div>
        <div style={{
            flexDirection: 'row',
            display: 'flex',
            marginTop: 12,
            gap: 8,
        }}>
            <div className='wave-background' style={{
                paddingTop: 12,
                borderRadius: 12,
                padding: 16,
                height: 128,
                width: 184,
            }}></div>
            <div className='wave-background' style={{
                paddingTop: 12,
                borderRadius: 12,
                padding: 16,
                height: 128,
                width: 184,
            }}></div>
        </div>
        <div className='wave-background' style={{
            marginTop: 12,
            marginLeft: 246,
            paddingTop: 12,
            borderRadius: 12,
            padding: 16,
            height: 40,
            width: 94,
        }}></div>

    </LiteTradeSearch>;
};

export default MobileMarketSkeleton;
